import React from 'react';
import {Button} from '../../../UI';
import {setCookie} from '../../../../utils/cookiesUtil';
import './CookieConsentModal.scss';

const CookieConsentModal = ({setIsModalVisible, setIsSettingsVisible}) => {
  const handleAcceptAll = () => {
    const cookieObj = {
      necessary: true, functional: true, analytical: true, marketing: true,
    };
    setCookie('cookieConsent', JSON.stringify(cookieObj));
    setIsModalVisible(false);
    window.location.reload();
  };

  const handleAcceptNecessary = () => {
    const cookieObj = {
      necessary: true, functional: false, analytical: false, marketing: false,
    };
    setCookie('cookieConsent', JSON.stringify(cookieObj));
    setIsModalVisible(false);
    window.location.reload();
  };

  const handleManage = () => {
    setIsSettingsVisible(true);
    setIsModalVisible(false);
  };

  return (
    <div className="cookie-modal-overlay">
      <div className="cookie-modal">
        <h2>Мы используем cookies</h2>
        <p>
          Сайт использует файлы cookie, чтобы сделать ваш просмотр безопасным и быстрым.
          Чтобы принимать все файлы cookie, включая аналитические, функциональные и рекламные, выберите Принять всё.
          Только для обязательных файлов cookie выберите Принять обязательные.
          Ознакомьтесь с нашей Политикой использования файлов cookie для получения подробной информации.
        </p>
        <div className="cookie-buttons">
          <Button className="decline-btn" onClick={handleManage} text='Настроить'/>
          <div className="cookie-accept-buttons">
            <Button className="decline-btn" onClick={handleAcceptNecessary} text='Принять обязательные'/>
            <Button className="accept-btn" onClick={handleAcceptAll} text='Принять все'/>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentModal;
